<template>
  <div class="main-content-container container">
    <div class="page-header row no-gutters py-4">
      <div class="col-6 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">sessão</span>
        <h3 class="page-title">Categorias de Contas a Pagar</h3>
      </div>

      <!-- Filters -->
      <div class="col-6 d-flex">
        <div class="input-group d-flex justify-content-end my-auto">
          <button
            type="button"
            class="btn btn-primary btn-sm mt-3"
            @click="OpenModalFilter()"
          >
            <i class="fas fa-filter"></i>
            {{ countFilter > 0 ? "Filtros aplicados" : "" }}
            <span v-if="countFilter > 0" class="badge badge-light">{{
              countFilter
            }}</span>
          </button>
          <button
            v-if="countFilter > 0"
            type="button"
            class="input-group-text btn-sm ml-1 mt-3"
            v-b-tooltip.hover.bottom
            title="Limpar filtros"
            @click="ResetFilter()"
          >
            <i class="fas fa-eraser"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Default Light Table -->
    <TableListAPC
      :lines="fields"
      :pagination.sync="pagination"
      :loadingList="loadingList"
      @List="ListAccountsPayableCategory"
      @Open="OpenField"
      @ConfirmDelete="ConfirmDeleteAccountsPayableCategory"
    />

    <b-modal
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      :title="modalTitle"
      id="mFormField"
      size="md"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>
      <div v-else>
        <ValidationObserver tag="form" ref="FieldValidationForm">
          <d-form-row>
            <!-- Code -->
            <d-col md="6" class="form-group" v-if="pOpened != null">
              <label>Código</label>
              <d-form-input disabled type="text" v-model="infoField.Code" />
            </d-col>
            <!-- Name -->
            <d-col :md="pOpened != null ? '6' : '12'" class="form-group">
              <label>Nome</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-form-input
                  :class="validatedFieldForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                  type="text"
                  v-model="infoField.Name"
                />
                <div class="invalid-feedback d-block" v-if="validatedFieldForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="12" class="form-group">
                        <label>Conta Contábil</label>
                        <d-form-input
                            :class="
                              validatedAccountsReceivableCategoryForm
                                | showValidateError(invalid)
                            "
                            :disabled="isSeeing"
                            type="text"
                            v-model="infoField.AccountCode"
                          />
                      </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveField()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      centered
      id="mFilter"
      title="Filtros"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            class="form-control"
            placeholder="Nome"
            type="text"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <d-select size="sm" v-model="filter.IsExcluded">
            <option :value="false">Ativos</option>
            <option :value="true">Inativos</option>
          </d-select>
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          @click="Filter()"
          class="btn btn-primary"
          title="Pesquisar"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          @click="ResetFilter()"
          class="input-group-text"
          title="Limpar filtros"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('AccountsPayableCategory', 'Add')"
      class="btn-float success"
      href="#"
      title="Nova categoria"
      v-b-tooltip.hover
      v-on:click="OpenField($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";

import TableListAPC from "../sub-components/AccountsPayableCategory/TableListAPC";

export default {
  name: "AccountsPayableCategory",
  components: {
    TableListAPC
  },
  data() {
    return {
      countFilter: 0,
      fields: [],
      filter: {
        Id: null,
        Code: null,
        Name: null,
        IsExcluded: false
      },
      idField: 0,
      infoField: {
        Name: null,
        AccountCode: null
      },
      isSeeing: false,
      loadingAddUpdate: false,
      loadingList: false,
      loadingModal: false,
      modalTitle: "Nova Categoria",
      pOpened: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      validatedFieldForm: false
    };
  },
  mounted() {
    this.ListAccountsPayableCategory();
  },
  methods: {
    OpenField(e, i, view) {
      e.preventDefault();
      this.validatedFieldForm = false;
      this.ResetInfoField();

      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.idField = this.fields[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar Campo";
        this.GetAccountsPayableCategory();
      } else if (view == undefined && i == undefined) {
        // Add new
        this.pOpened = null;
        this.isSeeing = false;
        this.modalTitle = "Nova categoria";
        this.ResetInfoField();
      } else {
        // View
        this.pOpened = i;
        this.idField = this.fields[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do Campo";
        this.GetAccountsPayableCategory();
      }
      this.$bvModal.show("mFormField");
    },
    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },
    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListAccountsPayableCategory();
    },
    ResetFilter() {
      this.filter = {
        Id: null,
        Code: null,
        Name: null,
        IsExcluded: false
      };
      this.ListAccountsPayableCategory();
    },
    ResetInfoField() {
      this.infoField = {
        Name: null,
        AccountCode: null
      };
    },
    SaveField() {
      this.validatedFieldForm = true;
      this.$refs.FieldValidationForm.validate().then(isValid => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            //this.infoField.Order = parseInt(this.infoField.Order, 10);
            this.$store
              .dispatch("AddAccountsPayableCategory", this.infoField)
              .then(() => {
                this.$makeToast(
                  "O campo foi cadastrado com sucesso.",
                  "success",
                  "Campo cadastrado"
                );
                this.ListAccountsPayableCategory();
                this.$bvModal.hide("mFormField");
              })
              .catch(error => {
                this.$makeToast(
                  "Tente novamente mais tarde.",
                  "danger",
                  "Erro ao criar campo",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.infoField.Order = parseInt(this.infoField.Order, 10);
            this.$store
              .dispatch("UpdateAccountsPayableCategory", this.infoField)
              .then(() => {
                this.$makeToast(
                  "O Campo foi atualizado com sucesso.",
                  "success",
                  "Campo atualizado"
                );
                this.ListAccountsPayableCategory();
                this.$bvModal.hide("mFormField");
              })
              .catch(error => {
                this.$makeToast(
                  "Erro ao atualizar campo, tente novamente.",
                  "danger",
                  "Erro ao atualizar campo",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    GetAccountsPayableCategory() {
      if (this.idField != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetAccountsPayableCategory", { id: this.idField })
          .then(response => {
            this.infoField = response;
          })
          .catch(error => {
            this.$makeToast(
              "Um erro ocorreu ao carregar o campo",
              "danger",
              "Erro ao carregar o campo",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ListAccountsPayableCategory() {
      this.loadingList = true;
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.IsExcluded)) this.countFilter++;
      let data = {
        ...this.pagination,
        "Object.Id": this.filter.Id,
        "Object.Code": this.filter.Code,
        "Object.Name": this.filter.Name,
        "Object.IsExcluded": this.filter.IsExcluded
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListAccountsPayableCategory", { params: data })
        .then(response => {
          this.fields = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(
            "Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger",
            "Erro ao listar os Campos",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },

    ConfirmDeleteAccountsPayableCategory(name, id) {
      this.$makeMsgBox(
        "Você tem certeza que deseja remover " + name + " ?",
        "Confirmar",
        this.DeleteAccountsPayableCategory,
        id
      );
    },
    DeleteAccountsPayableCategory(id) {
      this.$store
        .dispatch("DeleteAccountsPayableCategory", { id: id })
        .then(() => {
          this.$makeToast(
            "O Campo foi removido com sucesso.",
            "success",
            "Campo removido"
          );
          this.ListAccountsPayableCategory();
          this.$bvModal.hide("mFormField");
        })
        .catch(error => {
          this.$makeToast(
            "Tente novamente mais tarde.",
            "danger",
            "Erro ao remover Campo",
            error
          );
        });
    },
    preventDecimal(e) {
      if (e.code == "Comma" || e.code == "Period" || e.code == "Minus") {
        e.preventDefault();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/pages/AccountsPayableCategory.vue